import { render, staticRenderFns } from "./BreedPredicts.vue?vue&type=template&id=cabf0c28"
import script from "./BreedPredicts.vue?vue&type=script&lang=js"
export * from "./BreedPredicts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports